// noinspection JSIgnoredPromiseFromCall

import "../scss/app.scss";
import "cqfill";
import getConfig, {updateConfig} from "./config";
import AccessibleSlick from "./accessible-slick";
import Navbar from "./navbar";
import Retina from "./retina";
import setupAnnouncements from "./announcements";
import Bootstrap from "./bootstrap";
import setupCounterUp from "./counter-up";
import {setupFancybox} from "./fancybox";
import setupSassySocialShare from "./sassy-social-share";
import updateTimelines from "./timelines";
import {setupOverlaps} from "./overlaps";
import {setupDynamicHeights} from "./dynamic-heights";
import {setupMapplic} from "./mapplic";

const config = getConfig();

let lastScroll = document.documentElement.scrollTop;

const domLoaded = () => {
    updateViewportUnits();
    Navbar.updateNavBarHeight();
    Navbar.updateMainNavLinksTabIndexes();
    Navbar.setupNavbarToggler();
    Navbar.setupDropdownToggles();
    Navbar.setupNavLinks();
    Navbar.setupDropdownItems();
    Retina.retina();
    setupAnnouncements({}, loadResize);
    setupCounterUp();
    setupFancybox();
    Bootstrap.setup();
    AccessibleSlick.setupSlick();
    AccessibleSlick.setupTestimonialSliders();
    setupSassySocialShare();
    updateTimelines();
    setupOverlaps();
    setupDynamicHeights();
    setupMapplic();

    [...document.querySelectorAll("select.autosubmit")].forEach((select) =>
        select.addEventListener("change", () => select.form.submit()),
    );
    [...document.querySelectorAll("table")].forEach((table) => {
        if (!table.parentElement.classList.contains("table-wrap")) {
            table.outerHTML = `<div class="table-wrap">${table.outerHTML}</div>`;
        }
    });

    const emptyElsExceptions = [
        "area",
        "audio",
        "audio *",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "iframe",
        "img",
        "input",
        "link",
        "meta",
        "object",
        "object *",
        "param",
        "select *",
        "source",
        "svg *",
        "track",
        "video",
        "video *",
        "wbr",
    ].join(", ");
    [
        ...document.querySelectorAll(`#main *:not(${emptyElsExceptions})`),
    ].forEach((el) => {
        if (0 < el.children.length) {
            return;
        }

        const trimmedText = el.textContent.trim();

        if ("" === trimmedText) {
            el.textContent = trimmedText;
            el.classList.add("empty");
        }
    });
};
const loadResize = () => {
    updateViewportUnits();
    Navbar.updateNavBarHeight();
    Navbar.updateMainNavLinksTabIndexes();
    updateTimelines();
};
const scroll = () => {
    if (!config.masthead || document.body.classList.contains("menu-open")) {
        return;
    }

    let currentScroll = document.documentElement.scrollTop;

    if (currentScroll >= Navbar.getNavBarHeight()) {
        if (currentScroll > lastScroll) {
            config.masthead.classList.add("is-hidden");
            setTimeout(() => {
                config.masthead.classList.add("is-covering");
            }, 50);
        } else if (currentScroll < lastScroll) {
            config.masthead.classList.remove("is-hidden");
        }
    } else {
        config.masthead.classList.remove("is-hidden");
    }

    if (currentScroll < 1) {
        config.masthead.classList.remove("is-covering");
    }

    lastScroll = currentScroll;
};

const updateViewportUnits = () => {
    document.documentElement.style.setProperty(
        "--vw",
        `${(window.innerWidth / 100).toFixed(2)}px`,
    );
    document.documentElement.style.setProperty(
        "--vw-unit",
        `${(document.documentElement.clientWidth / 100).toFixed(2)}px`,
    );
    document.documentElement.style.setProperty(
        "--vh",
        `${(window.innerHeight / 100).toFixed(2)}px`,
    );
    document.documentElement.style.setProperty(
        "--vh-unit",
        `${(document.documentElement.clientHeight / 100).toFixed(2)}px`,
    );
};

const init = (config = {}) => {
    updateConfig(config);
    document.documentElement.classList.remove("no-js");
    document.documentElement.classList.add("js");

    if ("loading" === document.readyState) {
        document.addEventListener("DOMContentLoaded", domLoaded);
    } else {
        domLoaded();
    }

    addEventListener("load", () =>
        document.documentElement.classList.add("loaded"),
    );
    addEventListener("load", loadResize);
    addEventListener("resize", loadResize);
    addEventListener("scroll", scroll);
};

let appNameVarSafe = config.appName.replace(/[_-]([a-z])/g, (substr, letter) =>
    letter.toUpperCase(),
);
appNameVarSafe = appNameVarSafe.replace(/[_-]/g, "");
const globalConfigName = appNameVarSafe + "Config";
const globalConfig = window[globalConfigName] ?? {};
init(globalConfig);
window[appNameVarSafe + "GetConfig"] = getConfig;
